import React, { useEffect, useState } from "react";

function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault(); // stop auto prompt
      setDeferredPrompt(e);
      setShowButton(true); // show install button
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const installApp = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt(); // show install popup

    const choice = await deferredPrompt.userChoice;

    if (choice.outcome === "accepted") {
      console.log("User accepted install");
    } else {
      console.log("User dismissed install");
    }

    setDeferredPrompt(null);
    setShowButton(false);
  };

  return (
    <>
      {showButton && (
        <div style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          padding: 10,
          background: "#000",
          color: "#fff",
          borderRadius: 8
        }}>
          <p>Install our app?</p>
          <button onClick={installApp}>Install</button>
        </div>
      )}
    </>
  );
}

export default InstallPWA;